export const QRParentChildData= {
    GET_QRParentChildData: "GET_QRParentChildData"
   
}